import styled from 'styled-components';

interface TabsProps {
  variant?: 'default' | 'pills' | 'underline';
}

interface TabProps {
  active?: boolean;
  disabled?: boolean;
}

export const TabsContainer = styled.div<TabsProps>`
  display: flex;
  border-bottom: ${props => props.variant === 'underline' ? '1px solid #e5e7eb' : 'none'};
  background: ${props => props.variant === 'pills' ? '#f8f9fa' : 'transparent'};
  border-radius: ${props => props.variant === 'pills' ? '8px' : '0'};
  padding: ${props => props.variant === 'pills' ? '4px' : '0'};
  gap: ${props => props.variant === 'pills' ? '4px' : '0'};
`;

export const Tab = styled.button<TabProps>`
  padding: 12px 24px;
  border: none;
  background: ${props => {
    if (props.active) {
      return '#667eea';
    }
    return 'transparent';
  }};
  color: ${props => {
    if (props.disabled) return '#9ca3af';
    if (props.active) return 'white';
    return '#6b7280';
  }};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;
  position: relative;

  &:hover:not(:disabled) {
    background: ${props => props.active ? '#5a67d8' : '#f3f4f6'};
    color: ${props => props.active ? 'white' : '#374151'};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }

  ${props => props.active && `
    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      height: 2px;
      background: #667eea;
    }
  `}
`;

export const TabContent = styled.div`
  padding: 24px 0;
`;